<template>
  <v-app class="pa-3">
    <v-card class="card-login" v-show="showLogin">
      <v-layout>
        <v-flex xs12 class="text-lg-center">
          <img id="img-login" src="../assets/systock.png" />
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 class="text-lg-center">
          <h4
            v-if="!dadosValidos"
            style="color: red; margin: -20px 0px 10px 0px"
          >
            {{ mensagemErro }}
          </h4>

          <template v-if="habilitaMultiplasBases">
            <v-autocomplete
              v-model="grupoLicensaSelecionado"
              label="Empresa"
              :items="gruposLicencas"
              item-text="descricao"
              return-object
              outlined
              @change="trocarGrupoLicensa()"
            ></v-autocomplete>
          </template>

          <v-text-field
            v-model="email"
            :error-messages="emailErrors"
            outlined
            label="Digite Email"
            @keyup.enter="verificaSePodeChamarLogin()"
            @input="$v.email.$touch()"
            @blur="$v.email.$touch()"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 class="text-lg-center">
          <v-text-field
            v-model.trim="password"
            :error-messages="passwordErrors"
            outlined
            label="Digite Senha"
            :type="show1 ? 'text' : 'password'"
            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="show1 = !show1"
            @keyup.enter="verificaSePodeChamarLogin()"
            @input="$v.password.$touch()"
            @blur="$v.password.$touch()"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 class="text-lg-center">
          <v-btn
            block
            color="#D60E2B"
            :loading="loading"
            :disabled="loading"
            @click="verificarDadosLogin"
          >
            <h4 style="color: #fff">Entrar</h4>
            <template v-slot:loader>
              <span>Verificando...</span>
            </template>
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12>
          <EsqueciMinhaSenha @esqueci-minha-senha="showLogin = !$event" />
        </v-flex>
      </v-layout>
    </v-card>

    <v-dialog v-model="dialog_licenca" width="410">
      <v-card>
        <v-card-title ss="headline grey lighten-2" primary-title>
          <v-icon>mdi-alert</v-icon>&nbsp;Licença Vencida
        </v-card-title>
        <v-card-text> Entre em contato com o suporte. </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="primary" text @click="dialog_licenca = false"
            >Fechar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>
<script>
import { required, email } from "vuelidate/lib/validators";
import UsuarioAPI from "./../api/usuario";
import LicencasAPI from "./../api/licencas";
import EsqueciMinhaSenha from "./EsqueciMinhaSenha";
import UtilitariosAPI from "../api/utilitarios.js";

export default {
  components: { EsqueciMinhaSenha },
  data() {
    return {
      show1: false,
      email: "",
      password: "",
      dadosValidos: true,
      mensagemErro: "",
      loading: false,
      dialog_licenca: false,
      showLogin: true,
      grupoLicensaSelecionado: null,
      gruposLicencas: [],
      habilitaMultiplasBases: window.__APP_CONFIG__.VUE_APP_MULTI_DATABASE === "true",
      habilitar_ping_em_multiplas_base_url: window.__APP_CONFIG__.VUE_APP_MULTIPLAS_BASE_URL === "true"
    };
  },
  validations: {
    email: {
      required,
      email,
    },
    password: {
      required,
    },
  },
  mounted() {
    if (this.habilitaMultiplasBases) {
      this.buscarGruposComLicencas()
    }

    if (this.habilitar_ping_em_multiplas_base_url && !localStorage.baseUrl) {
      this.pingarNoServidor(window.__APP_CONFIG__.VUE_APP_URL_BASE, 0);
    }
  },
  computed: {
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.required && errors.push("Campo Obrigatório.");
      !this.$v.email.email && errors.push("Email Inválido.");
      return errors;
    },
  },
  methods: {
    trocarGrupoLicensa () {
      const { id, descricao, base_url, sigla } = this.grupoLicensaSelecionado

      if (id > 0 && descricao.length > 0 && base_url.length > 0 && sigla.length > 0) {
        localStorage.baseUrl = base_url.trim()
        this.limparCache()
      }
    },
    limparCache () {
      this.$store.dispatch("loadingAux/habilitarLoading", true)

      LicencasAPI.limparCache()
        .then(() => {
          window.location.reload(true)
          this.$store.dispatch("loading/habilitarLoading", false)
        })
        .catch(() =>
          this.$store.dispatch("loading/habilitarLoading", false)
        )
    },
    buscarGruposComLicencas () {
      this.$store.dispatch(
        "loading/addRequisicao",
        LicencasAPI.getListaGruposLicencas()
          .then(response => {
            if (!localStorage.baseUrl) {
              localStorage.baseUrl = window.__APP_CONFIG__.VUE_APP_URL_BASE
            }

            this.gruposLicencas = response.data.grupos

            const FILTRA_ITEM_DEFAULT = item => item.base_url.trim() === localStorage.baseUrl.trim()

            const itemFiltrado = this.gruposLicencas.filter(FILTRA_ITEM_DEFAULT)

            itemFiltrado[0] && (this.grupoLicensaSelecionado = itemFiltrado[0])
          })
      )
    },
    verificaSePodeChamarLogin() {
      if (!this.$v.$invalid) {
        this.verificarDadosLogin();
      }
    },

    verificarDadosLogin() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.login();
      }
    },
    getAcessos() {
      const headers = this.Helpers.iniciarRequisicao();

      UsuarioAPI.getAcessos(headers)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          const service = localStorage.getItem("service");

          if (response.status == 200) {
            if (response.data.acessos.length === 0) {
              alert("Usuário sem Permissão de Acesso!!!");
              this.Helpers.logout();
            } else {
              // rotas que podem ser acessadas sem esta cadastradas no perfil
              response.data.urls.push("/dashboard");
              response.data.urls.push("/compra");
              response.data.urls.push("/compras/produtos");
              response.data.urls.push("/logistica/mapa-separacao");
              localStorage.setItem("urls", response.data.urls);

              if (service === "S") {
                this.$router.push({ name: "drp" });
              } else {
                this.$router.push({ name: "Dashboard" });
              }
            }
          }
        })
        .catch(() => {
          this.Helpers.logout();
        });
    },
    loginNoOctadesk(nome, email, razao_social) {
      window.addEventListener('onOctaChatReady', function () {
        octadesk.chat.login({
          name: nome,
          email: email
        })
        octadesk.chat.setorganization({name: razao_social});
      });
    },
    login() {
      this.loading = true;

      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        email: this.email,
        password: this.password,
      };

      UsuarioAPI.login(headers, params)
        .then((response) => {
          this.loading = false;
          this.dadosValidos = true;

          const {token, habilitarLoteProduto, version } = response.data;
          localStorage.setItem("token", token);
          localStorage.setItem("app_version", version);

          const user = Object.assign({}, response.data.user);
          const empresa = Object.assign({}, response.data.empresa);

          localStorage.setItem("id", user.id);
          localStorage.setItem("nome", user.name);
          localStorage.setItem("email", user.email);
          localStorage.setItem("setor", user.setor);
          localStorage.setItem("service", user.service);
          localStorage.setItem("hash_acesso", user.hash_acesso);
          localStorage.setItem("visao_gerencial", user.visao_gerencial);
          localStorage.setItem("visualizar_inicio_cotacao", user.visualizar_inicio_cotacao || "N");
          localStorage.setItem("atualizacao_auto", user.atualizacao_auto);

          localStorage.setItem("empresa", empresa.razao_social);
          localStorage.setItem("filial_compra", empresa.filial_compra);
          localStorage.setItem("fator_atuacao", empresa.fator_atuacao);
          localStorage.setItem("conversao_embalagem", empresa.converter_emb_master);
          localStorage.setItem("confHabilitarLoteProduto", habilitarLoteProduto);
          localStorage.setItem("compras_analise_por_departamentos", empresa.compras_analise_por_departamentos);

          localStorage.setItem("integracao_exportacao_compra_protheus", empresa.integracao_protheus);
          localStorage.setItem("integracao_exportacao_compra_sankhya", empresa.integracao_sankhya);
          localStorage.setItem("integracao_sankhya_exibir_fornecedor", empresa.integracao_sankhya_exibir_fornecedor ? 'S' : 'N');

          localStorage.setItem("ativar_grupo_economico_compra", empresa.ativar_grupo_economico_compra ? 'S' : 'N');

          localStorage.setItem("url_chat_bot", empresa.url_chat_bot);
          localStorage.setItem("data_atual", response.data.data_atual);
          localStorage.setItem("preco_compra_grupo", empresa.preco_compra_grupo ? 'S' : 'N');
          localStorage.setItem("estetico_por_pp", empresa.estetico_por_pp ? 'S' : 'N');
          localStorage.setItem("integracao_exportacao_cisspoder_integrim", empresa.integracao_exportacao_cisspoder_integrim ? 'S' : 'N');
          localStorage.setItem("integracao_exportacao_automatiza", empresa.exportacao_automatiza ? 'S' : 'N');
          localStorage.setItem("config_lote_minimo_a_partir_de", empresa.lote_minimo_a_partir_de ? 'S' : 'N');
          localStorage.setItem("config_ativar_filtro_produtos_inativos_tela_compras", empresa.ativar_filtro_produtos_inativos_tela_compras ? 'S' : 'N');
          localStorage.setItem("integracao_exportacao_gemco", empresa.integracao_exportacao_gemco ? 'S' : 'N');
          localStorage.setItem("integracao_exportacao_citel", empresa.integracao_exportacao_citel ? 'S' : 'N');
          localStorage.setItem("existe_produtos_com_venda_futura", empresa.existe_produtos_com_venda_futura ? 'S' : 'N');
          localStorage.setItem("compras_exportacao_nativa_winthor", empresa.compras_exportacao_nativa_winthor ? 'S' : 'N');
          localStorage.setItem("compras_exportacao_api_consinco", empresa.compras_exportacao_api_consinco ? 'S' : 'N');
          localStorage.setItem("ativar_exibicao_campo_numero_original", empresa.ativar_exibicao_campo_numero_original ? 'S' : 'N');
          localStorage.setItem("diagnostico_ocultar_nivel_fornecedor", empresa.diagnostico_ocultar_nivel_fornecedor ? 'S' : 'N');
          localStorage.setItem("analiseGrupoFornecedores", 'N');
          localStorage.setItem("ocultar_considerar_estoque_grupo_na_compra_por_filial", empresa.ocultar_considerar_estoque_grupo_na_compra_por_filial ? 'S' : 'N');
          localStorage.setItem("compras_exibir_grupo_compras_usuario", empresa.compras_exibir_grupo_compras_usuario ? 'S' : 'N');

          if (empresa.ocultar_considerar_estoque_grupo_na_compra_por_filial) {
            localStorage.setItem('config_multifilial_considerar_estoque_grupo', 'N')
          }

          localStorage.setItem("compras_carrinho_ativar_consolidacao_pedidos_em_relatorios", empresa.compras_carrinho_ativar_consolidacao_pedidos_em_relatorios ? 'S' : 'N');
          localStorage.setItem("integracao_rms_drp_via_arquivo", empresa.integracao_rms_drp_via_arquivo ? 'S' : 'N');

          localStorage.setItem("config_grupo_compra_padrao", empresa.config_grupo_compra_padrao || 1);

          localStorage.setItem("carteira_comprador_ativar_limitacao_visualizacao", empresa.carteira_comprador_ativar_limitacao_visualizacao ? 'S' : 'N');
          localStorage.setItem("mix_produtos_filial_ativar_limitacao_visualizacao", empresa.mix_produtos_filial_ativar_limitacao_visualizacao ? 'S' : 'N');
          localStorage.setItem("comprador_usuario_id", response.data.comprador.id);
          localStorage.setItem("comprador_usuario_nome", response.data.comprador.nome_completo);

          localStorage.setItem("compras_conversao_embalagem_master_padrao", empresa.compras_conversao_embalagem_master_padrao ? 'S' : 'N');
          localStorage.setItem("ocultar_flag_apenas_qtde_pendente_maior_que_zero", empresa.ocultar_flag_apenas_qtde_pendente_maior_que_zero ? 'S' : 'N');
          localStorage.setItem("ativar_personalizacao_colunas_sys_data_table", empresa.ativar_personalizacao_colunas_sys_data_table ? 'S' : 'N');
          localStorage.setItem("compras_exibir_filtro_fora_linha_tela_compras_fornecedor", empresa.compras_exibir_filtro_fora_linha_tela_compras_fornecedor ? 'S' : 'N');

          //webcompras
          localStorage.setItem("compra_visualizar_webcotacao_ativo", empresa.compra_visualizar_webcotacao_ativo ? 'S' : 'N');

          this.$store.dispatch('usuario/setComprador', {
            id: response.data.comprador.id,
            nome: response.data.comprador.nome_completo
          });

          this.$store.commit("app/setUsuario", {
            nome: user.name,
            cargo: "Comprador",
            setor: user.setor,
            foto: require("../assets/user.png"),
          });

          if(empresa.filial_compra === 'N') {
            this.$store.dispatch('CompraDistribuidaPorFilial/set_distribuir_por_filial');
            this.$store.dispatch('CompraDistribuidaPorFilial/set_considerar_estoque_grupo');
          }

          this.getAcessos();
          this.Helpers.colocarEmTelaCheia();
        })
        .catch((error) => {
          this.loading = false;
          this.dadosValidos = false;
          switch (error.response.status) {
            case 401:
              this.mensagemErro = "Dados inválidos!";
              break;
            case 402:
              this.dialog_licenca = true;
              break;
            case 403:
              this.mensagemErro = "Usuário Desativado!";
              break;
            default:
              this.mensagemErro = "Erro inesperado!";
              break;
          }
        });
    },
    pingarNoServidor(base_url, tentativa) {
      const ping_sucesso = () => {
        if (localStorage.baseUrl === base_url) return;
        localStorage.baseUrl = base_url.trim()
        window.location.reload(true)
      };

      const ping_falhou = () => {
        tentativa++;
        if (!window.__APP_CONFIG__[`VUE_APP_URL_BASE_${tentativa}`]) return;
        this.pingarNoServidor(window.__APP_CONFIG__[`VUE_APP_URL_BASE_${tentativa}`], tentativa)
      };

      this.$store.dispatch("loadingAux/habilitarLoading", true);
      UtilitariosAPI.pingNoServidor(base_url).then(ping_sucesso).catch(ping_falhou);
    }
  },
};
</script>
<style scoped>
.theme--light.v-application {
  background-image: url("../assets/bg_home_min.png");
  background-size: cover;
}

.card-login {
  border-radius: 5px;
  padding: 10px 35px 10px 35px;
  margin: auto;
  min-width: 300px;
  max-width: 470px;
}
#img-login {
  width: 100%;
  margin: 18px 0 18px 0;
}
.hover-item-list:hover {
  background: rgba(0,0,0,.05);
}
@media (max-width: 450px) {
  .card-login {
    padding: 15px 20px 8px 20px;
  }
}
@media (max-width: 350px) {
  .card-login {
    padding: 15px 15px 8px 15px;
  }
}
</style>
